import HomeLayout from "../utils/Layouts/HomeLayout/HomeLayout";
import Banner from "../components/Home/Banner/Banner";
import CourseAbout from "../components/Home/CourseAbout/CourseAbout";
import TrainingsSection from "../components/Home/Training/TrainingsSection";
import HomeContact from "../components/Home/HomeContact/HomeContact";
import FreeCourse from "../components/Home/FreeCourse/FreeCourse";
import Partners from "../components/Partners/Partners";
import HomeNews from "../components/Home/HomeNews/HomeNews";
import Comments from "../components/Home/Comments/Comments";
import ScholarshipSection from "../components/Home/ScholarshipComponent/ScholarshipSection";

import ScholarshipComponent from "../components/Home/ScholarshipComponent/scholarship_component";

const Home = () => {
  return (
    <HomeLayout>
      <div className="home-container">
        <Banner />

        <TrainingsSection />
        <FreeCourse />
        <ScholarshipSection />
        <Partners />
        <HomeNews />
        <Comments />
      </div>
    </HomeLayout>
  );
};

export default Home;
